import { useSelector } from "react-redux";
import ContentWithCards from "../components/shared/ContentWithCards";
import UserProfile from "../components/profile/UserProfile";

const Profile = () => {
  const userData = useSelector((state) => state.auth?.userData);
  const privacySettings = useSelector((state) => state.user?.privacySettings);

  return (
    <ContentWithCards>
      <UserProfile 
        userData={userData} 
        privacySettings={privacySettings}
        profileUserId={userData?._id}
      />
    </ContentWithCards>
  );
};

export default Profile;
